import React from 'react';

const AppointmentComments = ({ comments }) => {
    if (!comments || comments.length < 1) {
        return null;
    }

    return (
        <div className="form-group">
            <div className="pt-12">
                <label>Comments</label>
            </div>
            <div className="table-responsive">
                <table className="appointment-comment table">
                    <tbody>
                        {comments.map((comment, index) => {
                            return (
                                <tr key={index}>
                                    <td>
                                        <div className="comment mb-8" style={{ whiteSpace: 'pre-wrap' }}>
                                            {comment.comment}
                                        </div>
                                        <div className="author text-primary">{comment.author}</div>
                                        <div className="date text-disabled">{comment.date}</div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AppointmentComments;
